import * as React from 'react';
import { useState, useEffect } from 'react';
import { useQuery, Direction } from './Query';
import { FilterHeader } from './QueryTable';
import Modal, { ModalSize } from '../misc/components/modal';

export interface Option {
    label: any;
    value: any
}

interface NumericRangeMatchSortHeaderProps {
    title: string;
    field: string;
    sortField?: string;
    automationId?: string;
}

export const NumericRangeMatchSortHeader = ({ title, field, sortField = null, automationId }: NumericRangeMatchSortHeaderProps) => {

    const [display, setDisplay] = useState(false);
    const { filters, ordering, applyOrdering } = useQuery();
    const [ordered, setOrdered] = useState<Direction>();
    const [filtered, setFiltered] = useState(false);
    sortField = sortField ?? field;

    useEffect(() => {
        const filtered = filters.some(f => f.field === field && (f.condition === 'ge' || f.condition === 'le'));
        setFiltered(filtered);
    }, [filters]);

    useEffect(() => {

        const ordered = ordering.find(o => o.field === sortField);
        setOrdered(ordered
            ? ordered.condition
            : null);
    }, [ordering]);

    const handleSort = () => {
        let direction: Direction = 'asc';

        if (ordered === 'asc')
            direction = 'desc';

        applyOrdering([{ field: sortField, condition: direction }]);
    }

    const handleFilter = () => {
        setDisplay(true);
    }

    const modal = display
        ? (
            <NumericRangeMatchFilterModal title={title} field={field} onClose={() => setDisplay(false)} />
        )
        : null;

    return (
        <>
            <FilterHeader automationId={automationId} filtered={filtered} sorted={ordered} onFilter={handleFilter} onSort={handleSort}>{title}</FilterHeader>
            {modal}
        </>
    );
}

interface NumericRangeMatchFilterModalProps {
    title: string;
    field: string;
    onClose: () => void;
}

export const NumericRangeMatchFilterModal = ({ title, field, onClose }: NumericRangeMatchFilterModalProps) => {
    const valueFormat = 'YYYY-MM-DD';

    const [valueFrom, setValueFrom] = useState<number>();
    const [valueTo, setValueTo] = useState<number>();
    const { filters, applyFilters, paging, applyPaging } = useQuery();

    useEffect(() => {
        const currentValueFrom = filters
            .filter(f => f.field === field && f.condition === 'ge')
            .flatMap(f => f.values);

        if (currentValueFrom.length > 0) {
            setValueFrom(currentValueFrom[0]);
        }

        const currentValueTo = filters
            .filter(f => f.field === field && f.condition === 'le')
            .flatMap(f => f.values);

        if (currentValueTo.length > 0) {
            setValueTo(currentValueTo[0]);
        }
    }, [filters]);

    const handleApply = () => {

        let newFilters = filters.filter(f => f.field !== field);
        if (valueFrom) {
            newFilters.push({
                field: field,
                condition: 'ge',
                values: [valueFrom],
            })
        }

        if (valueTo) {
            newFilters.push({
                field: field,
                condition: 'le',
                values: [valueTo],
            })
        }
        applyPaging({ ...paging, page: 1 });
        applyFilters(newFilters);
        onClose();
    }

    const handleClear = () => {

        applyPaging({ ...paging, page: 1 });
        applyFilters(filters.filter(f => f.field !== field));
        onClose();
    }



    return (
        <Modal header={`${title} Filter`} size={ModalSize.Normal} show={true} closeModalHandler={onClose}>
            <div className="modal-body">
                <div className="row">
                    <div className='col-md-6 form-group'>
                        <label>From</label>
                        <input type='number' onChange={(e) => setValueFrom(Number(e.target.value))} value={valueFrom} className='form-control' />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label>To</label>
                        <input type='number' onChange={(e) => setValueTo(Number(e.target.value))} value={valueTo} className='form-control'  />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleApply} data-automationid="submit-filter">OK</button>
                <button className="btn btn-danger" onClick={handleClear} data-automationid="clear-filter">Clear</button>
            </div>
        </Modal>
    );
};
